import { api } from "api";

export const getNotifications = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/notification/get")
      .then((res) => {
        dispatch({
          type: "GET_NOTIFICATIONS_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_NOTIFICATIONS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const markNotificationAsSeen = (
  notificationId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/notification/seen", { notificationId: notificationId })
      .then((res) => {
        dispatch({
          type: "MARK_NOTIFICATION_AS_SEEN_SUCCESS",
          payload: res.data,
        });

        onSuccess(notificationId);
      })
      .catch((e) => {
        dispatch({
          type: "MARK_NOTIFICATION_AS_SEEN__ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
